import { z } from 'zod'
import { required } from '@portal/pkg-hook-form'
import { LicenseType } from '@portal/pkg-api/gen/admin-console'

export { LicenseType }

export const IntegrationRoleOption = {
  NOT_SELECTED: 'NOT_SELECTED',
  ANALYST: 'ANALYST',
  OPERATOR: 'OPERATOR',
  ADMIN: 'ADMIN',
} as const

export const NotificationFrequencyOption = {
  IMMEDIATELY: 'IMMEDIATELY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const

export const AddUserSchema = z.object({
  givenName: z.string().superRefine(required()),
  familyName: z.string().superRefine(required()),
  email: z.string().superRefine(required()).pipe(z.string().email()),
  licenseType: z.nativeEnum(LicenseType),
  integrationsRole: z.string(),
  projectParticipant: z.boolean(),
  emailNotifications: z.boolean(),
  notificationFrequency: z.string(),
})

export type AddUserFormValues = z.infer<typeof AddUserSchema>

export const addUserDefaults: AddUserFormValues = {
  givenName: '',
  familyName: '',
  email: '',
  licenseType: LicenseType.LITE,
  integrationsRole: IntegrationRoleOption.NOT_SELECTED,
  projectParticipant: true,
  emailNotifications: true,
  notificationFrequency: NotificationFrequencyOption.WEEKLY,
}
